export const EMP_REQUEST = "EMP_REQUEST";
export const EMP_SUCCESS = "EMP_SUCCESS";
export const EMP_FAIL = "EMP_FAIL";
export const EMP_CLEAR_ERRORS = "EMP_CLEAR_ERRORS";

export const UPDATE_EMP_REQUEST = "UPDATE_EMP_REQUEST";
export const UPDATE_EMP_SUCCESS = "UPDATE_EMP_SUCCESS";
export const UPDATE_EMP_FAIL = "UPDATE_EMP_FAIL";
export const UPDATE_EMP_CLEAR_ERRORS = "UPDATE_EMP_CLEAR_ERRORS";

export const EMP_IMPORT_REQUEST = "EMP_IMPORT_REQUEST";
export const EMP_IMPORT_SUCCESS = "EMP_IMPORT_SUCCESS";
export const EMP_IMPORT_FAIL = "EMP_IMPORT_FAIL";
export const EMP_IMPORT_CLEAR_ERRORS = "EMP_IMPORT_CLEAR_ERRORS";

// get Employees by search

export const EMP_SEARCH_REQUEST = "EMP_SEARCH_REQUEST";
export const EMP_SEARCH_SUCCESS = "EMP_SEARCH_SUCCESS";
export const EMP_SEARCH_FAIL = "EMP_SEARCH_FAIL";
export const EMP_SEARCH_CLEAR_ERRORS = "EMP_SEARCH_CLEAR_ERRORS";

// employees search by designation and department wise
export const EMP_BY_REQUEST = "EMP_BY_REQUEST";
export const EMP_BY_SUCCESS = "EMP_BY_SUCCESS";
export const EMP_BY_FAIL = "EMP_BY_FAIL";
export const EMP_BY_CLEAR_ERRORS = "EMP_BY_CLEAR_ERRORS";


// employees search by id
export const EMP_BY_ID_REQUEST = "EMP_BY_ID_REQUEST";
export const EMP_BY_ID_SUCCESS = "EMP_BY_ID_SUCCESS";
export const EMP_BY_ID_FAIL = "EMP_BY_ID_FAIL";
export const EMP_BY_ID_CLEAR_ERRORS = "EMP_BY_ID_CLEAR_ERRORS";

export const LOCK_REQUEST = "LOCK_REQUEST";
export const LOCK_SUCCESS = "LOCK_SUCCESS";
export const LOCK_FAIL = "LOCK_FAIL";
export const LOCK_CLEAR_ERRORS = "LOCK_CLEAR_ERRORS";